import { SearchspringSearchProvider } from 'libs/searchspring/fetchers/search'

import clsx from 'clsx'

import { useEffect, useState } from 'preact/hooks'
import { useScrollCache } from 'libs/searchspring/hooks/useScrollCache'
import { useFilterScroll } from 'libs/searchspring/hooks/useFilterScroll'
import { useScrollPositionKeeper } from 'libs/searchspring/hooks/useScrollPositionKeeper'
import { scrollHistoryManager } from 'helpers/scroll-history'
import { useInfiniteScrollResults } from 'libs/searchspring/hooks/useInfiniteScrollResults'
import { InfiniteScrollNext, InfiniteScrollPrevious } from 'libs/searchspring/components/collection/InfiniteScroll'
import { useOption } from 'libs/searchspring/hooks/useOption'
import { FiltersProvider } from 'libs/searchspring/hooks/useFilters'
import { CollectionToolbar } from 'libs/searchspring/components/collection/CollectionToolbar'
import { FilterDrawer } from 'libs/searchspring/components/collection/filters/FilterDrawer'
import { SearchHeader } from 'libs/searchspring/components/SearchHeader'
import { ResultItem } from 'libs/searchspring/components/ResultCardWrapper'

function SearchGrid({ showFilters }) {
  history.scrollRestoration = 'manual'
  const [firstLoad, setFirstLoad] = useState(true)
  const { allResults, gridChange, isLoading, results } = useInfiniteScrollResults()
  const { setEntry } = useScrollPositionKeeper(gridChange)
  const { setScrollElement } = useFilterScroll()
  const query = useOption(
    'query',
    { syncWithURL: true }
  )

  const { corrected = '', original = '' } = results?.query || {}
  const didYouMean = results?.didYouMean?.query || ''

  const corrections = {
    corrected,
    original,
    didYouMean
  }

  useEffect(() => {
    if (!isLoading) setFirstLoad(false)
  }, [isLoading])

  useScrollCache([allResults, firstLoad])

  const totalResults = results?.pagination?.totalResults || 0

  return (
    <div className="grow flex flex-col">
      <SearchHeader query={query} totalResults={totalResults} isLoading={isLoading} corrections={corrections}/>
      <FiltersProvider>
        {allResults.length > 0 && (
          <>
            <CollectionToolbar />
            <div className="grow flex flex-col md:grid md:grid-cols-min-full md:px-margin">
              <FilterDrawer showFilters={showFilters} />
              <div className="grow flex flex-col">
                <div
                  ref={(el) => { setScrollElement(el); setEntry(el) }}
                  className={clsx('grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 xxxl:grid-cols-5 [grid-auto-flow:row_dense] gap-x-gutter gap-y-2 w-full lg:pt-2', (isLoading && firstLoad) && 'min-h-screen-height')}
                >
                  <InfiniteScrollPrevious />
                    {
                      allResults?.map((item, index) => {
                        return <ResultItem item={item} key={item.handle} className="wk-wishlist-button-target" dataIndex={index.toString()} />
                      })
                    }
                </div>
                {!firstLoad && (
                  <div className="flex justify-center px-margin py-3.5">
                    <InfiniteScrollNext />
                  </div>
                )}
              </div>
            </div>
          </>
        )}
      </FiltersProvider>
    </div>
  )
}

export function WrappedSearchGrid({ 'show-filters': showFilters }) {
  scrollHistoryManager.updateHistoryState()
  const urlParams = new URLSearchParams(window.location.search)
  const queryParam = urlParams.get('query')
  return (
    <SearchspringSearchProvider query={queryParam}>
      <SearchGrid showFilters={showFilters === 'true'} />
    </SearchspringSearchProvider>
  )
}
